import { useState, useEffect } from 'react';
import { supabase, Database } from '../lib/supabase';
import { getRecommendedActivitiesForAge } from '../lib/activity-seeding';

type Activity = Database['public']['Tables']['activities']['Row'];

export function useActivities() {
  const [activities, setActivities] = useState<Activity[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const { data, error } = await supabase
          .from('activities')
          .select('*')
          .order('difficulty_level', { ascending: true });

        if (error) throw error;
        setActivities(data || []);
      } catch (error) {
        console.error('Error fetching activities:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchActivities();
  }, []);

  const getActivitiesBySubject = (subject: string) => {
    return activities.filter(activity => activity.subject === subject);
  };

  const getActivitiesByDifficulty = (difficulty: number) => {
    return activities.filter(activity => activity.difficulty_level === difficulty);
  };

  const getActivitiesForAge = (age: number) => {
    // Use the age-appropriate filtering logic
    return getRecommendedActivitiesForAge(age);
  };

  return {
    activities,
    loading,
    getActivitiesBySubject,
    getActivitiesByDifficulty,
    getActivitiesForAge,
  };
}